export default "__VITE_ASSET__8199601c__"